const PLAN_NAME = Object.freeze({
  essential: 'Essential',
  advanced: 'Advanced',
  supercharged: 'Supercharged',
});

export default PLAN_NAME;
